import { __extends, __assign } from 'tslib';
import * as React from 'react';
import { UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { classNames, analyticsTracker } from 'uitk-react-utils';
import { UitkToolbarExpandedState, Toolbar } from './toolbar.esm.js';
import styles from './uitk-toolbar.css';

var getClassNameList = classNames.bind(styles);
var UitkToolbarButton = /** @class */ (function (_super) {
    __extends(UitkToolbarButton, _super);
    function UitkToolbarButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkToolbarButton.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, onClick = _a.onClick, buttonRef = _a.buttonRef, onClickAnalytics = _a.onClickAnalytics, buttonId = _a.buttonId, expandedState = _a.expandedState, containerId = _a.containerId, children = _a.children;
        var analytics = onClickAnalytics && __assign({ localAnalyticsId: 'Close' }, onClickAnalytics);
        var iconContent;
        var buttonLabel;
        // Map through the children and place the ones we want in specific places
        React.Children.forEach(children, function (child) {
            var _a;
            if (!child) {
                return;
            }
            if (((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === 'UitkIcon' && !iconContent) {
                iconContent = child;
            }
            else if (typeof child === 'string' && !buttonLabel) {
                buttonLabel = child;
            }
        });
        // Clean up 'v2' extension in class in EGDS graduation hard breaking change
        var baseClass = "".concat(Toolbar.baseClassName, "-button-v2");
        var contentClass = "".concat(baseClass, "-content");
        var wrapperClassName = getClassNameList(baseClass, !buttonLabel && "".concat(baseClass, "-icon-only"), buttonLabel && "".concat(baseClass, "-has-label"));
        var contentClassNames = getClassNameList(contentClass, !buttonLabel && "".concat(contentClass, "-icon-only"), buttonLabel && "".concat(contentClass, "-has-label"));
        return (React.createElement(UitkLayoutFlexItem, { className: wrapperClassName, shrink: 0 },
            React.createElement("button", { type: "button", disabled: disabled, onClick: onClick, onClickCapture: analyticsTracker.bind(this, analytics), ref: buttonRef, id: buttonId, "aria-expanded": expandedState === UitkToolbarExpandedState.EXPANDED, "aria-controls": containerId },
                React.createElement("span", { className: contentClassNames },
                    iconContent,
                    buttonLabel && React.createElement("span", { className: getClassNameList("".concat(contentClass, "-label")) }, buttonLabel)))));
    };
    UitkToolbarButton.displayName = 'UitkToolbarButton';
    return UitkToolbarButton;
}(React.Component));

export { UitkToolbarButton };
